<template>
  <div>
    <h1>This is the subscription page</h1>
  </div>
</template>

<script>
export default {
  name: "Subscribe",
  data() {
    return {};
  },
  methods: {},
};
</script>
